<template>
  <div class="c-content-container">
    <h3 class="t-heading-2">
      {{ title }}
    </h3>
    <div class="t-paragraph-large--base">
      {{ description }}
    </div>
    <div
      v-for="section in sections"
      :key="section.id"
      class="c-content-container__component"
    >
      <component
        :is="section.contentType"
        v-if="section.contentType"
        :id="section.handle"
        v-bind="section.data"
        :get-product-function="getProductFunction"
      />
    </div>
  </div>
</template>
<script>
import Row from "../layout/Row"

export default {
  name:"ContentContainer",
  components: {
    Row
  },
  props:{
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    sections: {
      type: Array,
      default: () => []
    },
    getProductFunction: {
      type: Function,
      required: true
    }
  },
  methods: {
  }
}
</script>
<style  lang="scss" scoped >
.c-content-container{
}
</style>
